import store from '../'

let resource = store.defineResource({
  name: "media"
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/media.js